import React, { useState } from 'react'
import categorys from "../../assets/icons/unitsIcons/unitCategory.png"
import unitsIcon from "../../assets/icons/unitsIcons/units.png"
const AllUnitsHooks = () => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
  
    const [search, setSearch] = useState(false)
  
  
    const NavItems = [
        { name: "Unit Category & Type", to: "/category", icon: categorys },
        { name: "Units", to: "/units/allunits", icon: unitsIcon },
      ];
  
  
    return {
      NavItems,
      setSearch,
      handleShow,
      show,
      handleClose
    }
}

export default AllUnitsHooks